import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UafService } from 'src/app/global/services/uaf.service';
import { BancoServiceVM } from 'src/app/view-model/services/banco-vm.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { UafServiceVM } from 'src/app/view-model/services/uaf-vm.service';
import { LocalStorageService } from '../../../../global/services/localstorage.service';


@Injectable()
export class UafProviderVM extends UafServiceVM {

    constructor(
        private uafService: UafService,
        private bancoServiceVM: BancoServiceVM,
        private rutFormatter: RutFormatterService,
        private storage: LocalStorageService,
    ) {
        super();
    }

    postFormularioUaf(formUaf: any): Observable<any> {
        return this.uafService.saveDeclaracion(formUaf).pipe();
    }
}
